import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const TypeConstantSum = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
      <path d="M18 6H8.83L14.83 12L8.83 18H18V20H6V18L12 12L6 6V4H18V6Z" />
    </SvgIcon>
  )
);

TypeConstantSum.displayName = 'TypeConstantSum';

export default TypeConstantSum;
